<div class="w-full">

  <!-- TOOLBAR -->
<div class="mb-6 grid grid-cols-12">
  <div class="col-span-12">
    <div class="grid grid-cols-12 items-center gap-4 rounded-2xl border border-gray-300 bg-white/95 p-4 backdrop-blur">

      <!-- LEFT: CREATE BUTTON -->
      <div class="col-span-12 md:col-span-3">
        <div class="flex justify-start">
          <button
            class="primary-btn h-[50px] w-full rounded-xl px-5 text-sm font-semibold transition md:w-auto"
            (click)="createNewPost()"
          >
            Create New Post
          </button>
        </div>
      </div>

      <!-- CENTER: SEARCH -->
      <div class="col-span-12 md:col-span-5">
        <div class="flex justify-center">
          <div class="grid h-[50px] w-full max-w-[520px] grid-cols-12 items-center rounded-xl border border-gray-300 bg-gray-50 px-3 transition focus-within:border-gray-300 focus-within:bg-white">

            <mat-icon class="col-span-1 text-gray-400">
              search
            </mat-icon>

            <input
              #searchInput
              type="text"
              placeholder="Search..."
              [(ngModel)]="searchValue"
              (keyup.enter)="onSearchSubmit(searchInput.value)"
              (input)="searchValue = searchInput.value"
              class="col-span-10 min-w-0 bg-transparent px-2 text-sm text-gray-700 outline-none placeholder-gray-400"
            />

            <button
              type="button"
              (click)="clearSearch(); searchInput.value=''; searchValue=''"
              [class.opacity-0]="!searchValue"
              [class.pointer-events-none]="!searchValue"
              class="col-span-1 grid place-items-center rounded-full p-1.5 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
            >
              <mat-icon class="cursor-pointer text-lg">
                close
              </mat-icon>
            </button>

          </div>
        </div>
      </div>

      <!-- RIGHT: PAGINATOR -->
      <div class="col-span-12 md:col-span-4">
        <div class="flex justify-start overflow-x-auto md:justify-end">
          <div class="h-[50px] min-w-max overflow-hidden rounded-xl border border-gray-300 bg-white">
            <mat-paginator
              [length]="totalItems"
              [pageSize]="pageSize"
              [pageSizeOptions]="[pageSize]"
              showFirstLastButtons
              (page)="onPageChange($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

  <!-- TABLE CARD -->
  <div class="overflow-hidden rounded-2xl border border-gray-300 bg-white">

    <div class="w-full overflow-x-auto">
      <mat-table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="!inline-table !w-full min-w-[1180px] table-fixed text-sm"
        style="border-collapse: collapse; border-spacing: 0;"
      >

        <!-- Ribbon / New -->
        <ng-container matColumnDef="new_post">
          <th mat-header-cell *matHeaderCellDef class="bg-gray-50 px-3 py-4"></th>

          <td mat-cell *matCellDef="let element" class="relative px-4 py-6">
            <div
              class="ribbon-left absolute left-0 top-0"
              [ngClass]="{
                'ribbon-success': element.post_status === 'PostedOnFacebook' || element.post_status === 'PostedOnInstagram' || element.post_status === 'PostedOnTikTok',
                'ribbon-failed': element.post_status === 'Fail' || element.post_status === 'Permanently Failed',
                'ribbon-pending': element.post_status === 'Draft'
              }"
            >
            </div>

            <div class="ribbon-right" *ngIf="isScheduledForToday(element.scheduled_for)">
              New
            </div>
          </td>
        </ng-container>

        <!-- ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            ID
          </th>

          <td mat-cell *matCellDef="let element" class="whitespace-nowrap px-5 py-5 text-sm font-medium text-gray-800">
            {{ element.id }}
          </td>
        </ng-container>

        <!-- Domain -->
        <ng-container matColumnDef="domain_name">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Domain
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-center">
            <div class="flex justify-center">
              <ng-container *ngIf="domainSlug(element.domain_name) as slug; else noLogo">
                <div class="h-10 w-10 overflow-hidden rounded-full ring-1 ring-gray-300">
                  <img
                    class="h-full w-full object-cover"
                    [src]="element.thumbnail_file_path"
                    (error)="onMainImgError($event)"
                  />
                </div>
              </ng-container>

              <ng-template #noLogo>
                <div class="h-10 w-10 rounded-full bg-gray-200"></div>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <!-- Title -->
        <ng-container matColumnDef="rss_title">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Title
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5">
            <div class="max-w-[500px] break-words text-sm leading-6 text-gray-800">
              {{ element.rss_title }}
            </div>
          </td>
        </ng-container>

        <!-- Platform -->
        <ng-container matColumnDef="platform_tag">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Platform / Type
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm leading-relaxed text-gray-700">
            {{ formatPlatformTag(element.social_platform_title, element.tag) }}
          </td>
        </ng-container>

        <!-- Week -->
        <ng-container matColumnDef="week_day">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Day
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm text-gray-700">
            {{ weekDays[element.week_day] }}
          </td>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef="scheduled_for">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Scheduled
          </th>

          <td mat-cell *matCellDef="let element" class="whitespace-nowrap px-5 py-5 text-sm text-gray-700">
            {{ element.scheduled_for | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="post_status">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Status
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm text-gray-700">
            {{ postStatusForm(element.post_status) }}
          </td>
        </ng-container>

        <!-- Dot -->
        <ng-container matColumnDef="status_icon">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            ●
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-center">
            <span
              class="inline-block h-4 w-4 rounded-full"
              [ngClass]="{
                'bg-green-500': element.post_status === 'PostedOnFacebook' || element.post_status === 'PostedOnInstagram' || element.post_status === 'PostedOnTikTok',
                'bg-red-500': element.post_status === 'Fail' || element.post_status === 'Permanently Failed',
                'bg-gray-300': element.post_status !== 'Fail' && element.post_status !== 'Permanently Failed'
              }"
            >
            </span>
          </td>
        </ng-container>

        <!-- Source -->
        <ng-container matColumnDef="source">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Source
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm text-gray-700">
            {{ element.source }}
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Actions
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5">
            <div class="flex items-center justify-end gap-2">
              <button
                mat-icon-button
                class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                [disabled]="['PostedOnInstagram','PostedOnFacebook'].includes(element.post_status) || element.enable_repeat === -1"
                (click)="editRow(element)"
              >
                <mat-icon matTooltip="Edit">edit</mat-icon>
              </button>

              <button
                mat-icon-button
                class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                [disabled]="['Draft','Fail','Permanently Failed'].includes(element.post_status)"
                (click)="reuseRow(element)"
              >
                <mat-icon matTooltip="Reuse">replay</mat-icon>
              </button>

              <button
                mat-icon-button
                class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                (click)="viewRow(element)"
              >
                <mat-icon matTooltip="Preview">search</mat-icon>
              </button>

              <button
                mat-icon-button
                class="cursor-pointer text-gray-600 transition-colors hover:text-red-600"
                [disabled]="element.post_status === 'PostedOnFacebook' || element.post_status === 'PostedOnInstagram' || element.post_status === 'PostedOnTikTok'"
                (click)="openDeleteConfirm(element)"
              >
                <mat-icon matTooltip="Delete">delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Repeat -->
        <ng-container matColumnDef="enable_repeat">
          <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
            Repeat
          </th>

          <td mat-cell *matCellDef="let element" class="px-5 py-5 text-sm leading-relaxed text-gray-700">
            <div class="flex items-center gap-2">

              <ng-container *ngIf="element.enable_repeat === -1; else normalRepeat">
                <span class="italic text-gray-400">
                  Original post id: {{ element.parent_post_id }}
                </span>
              </ng-container>

              <ng-template #normalRepeat>
                <ng-container
                  *ngIf="element.post_status !== 'PostedOnInstagram' && element.post_status !== 'PostedOnFacebook'; else repeatControls"
                >
                  <span class="italic text-gray-400">
                    Not available
                  </span>
                </ng-container>

                <ng-template #repeatControls>
                  <span [class.text-green-600]="element.enable_repeat === 1">
                    {{ element.enable_repeat === 1 ? 'Enabled' : 'Disabled' }}
                  </span>

                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                    (click)="repeatPostRow(element)"
                  >
                    <mat-icon [class.text-green-600]="element.enable_repeat === 1">
                      repeat
                    </mat-icon>
                  </button>
                </ng-template>
              </ng-template>

            </div>
          </td>
        </ng-container>

        <!-- Rows -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="border-b border-gray-300 bg-gray-50"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="border-b border-gray-100 bg-white transition-colors even:bg-gray-50/40 hover:bg-gray-100"
        ></tr>

      </mat-table>
    </div>

  </div>

  <!-- Empty -->
  <ng-container *ngIf="!isLoading && (!dataSource || dataSource.data.length === 0)">
    <div class="mt-6 text-center text-sm text-gray-400">
      No posts found.
    </div>
  </ng-container>

  <!-- Bottom paginator -->
  <div class="mt-6 grid grid-cols-12">
    <div class="col-span-12">
      <div class="flex items-center justify-end overflow-x-auto rounded-2xl border border-gray-300 bg-white/95 px-3 py-2 backdrop-blur">
        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageSizeOptions]="[pageSize]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </div>

</div>